/* -------------------------------------------------------------------
   KV: rotate a product card through its sibling colourways in place.

   Clicking a swatch on a collection card swaps the card over to that
   colourway instead of navigating. Clicking the card IMAGE (or title)
   still goes through to the product page — those are ordinary links and
   this script never touches them.

   Everything the swap needs is carried on the swatch itself as data-kv-*
   attributes, written by snippets/card-product-siblings.liquid.

   TWO THINGS THAT HAVE BITTEN US, BOTH WORTH KEEPING IN MIND:

   1. `.card-information` is the WRAPPER holding the price AND the swatch
      list. Writing innerHTML on it destroys the swatches. Price and badge
      are each swapped by replacing their OWN element. Do not "simplify"
      these back into an innerHTML assignment on the wrapper.

   2. data-kv-price / data-kv-badge are written only when the sibling
      DIFFERS FROM THE CARD'S ORIGINAL PRODUCT, so a swatch that matches
      the original carries neither. Skipping the swap in that case leaves
      whatever the last click put there — e.g. a sale price stranded on a
      full-price colourway. So we snapshot the card's starting price and
      badge before the first swap and restore them whenever a swatch has
      no attribute of its own. Absent means "same as original", never
      "leave it alone".

   Fails safe: if anything expected is missing, the click is left alone
   and the browser follows the link as before.
   ------------------------------------------------------------------- */
(function () {
  "use strict";
  if (window.__kvSiblingSwap) return;
  window.__kvSiblingSwap = true;

  var PRICE_SELECTOR =
    ".card-information .price, .card__information .price, .card__content .price";

  function swapImage(wrapper, src) {
    if (!wrapper) return;
    var img = wrapper.tagName === "IMG" ? wrapper : wrapper.querySelector("img");
    if (!img || !src) return;
    // Drop srcset so the browser cannot keep serving the old colourway.
    img.removeAttribute("srcset");
    img.removeAttribute("data-srcset");
    img.setAttribute("src", src);
  }

  /* The card as it was rendered, captured once before we touch it. */
  function baseline(card) {
    if (card.__kvBaseline) return card.__kvBaseline;
    var price = card.querySelector(PRICE_SELECTOR);
    var badge = card.querySelector(".card__badge");
    card.__kvBaseline = {
      price: price ? price.outerHTML : null,
      badge: badge ? badge.outerHTML : null
    };
    return card.__kvBaseline;
  }

  /* Parse an escaped HTML fragment and swap in the one element we want,
     leaving every sibling node in the host container untouched. */
  function replaceFragment(host, html, selector) {
    if (!host || html === null || html === undefined) return;
    var holder = document.createElement("div");
    holder.innerHTML = html;
    var replacement = holder.querySelector(selector);
    if (replacement) {
      host.replaceWith(replacement);
    } else {
      host.innerHTML = "";
    }
  }

  document.addEventListener(
    "click",
    function (event) {
      var swatch = event.target.closest("[data-kv-url]");
      if (!swatch) return;

      var card = swatch.closest(".card-wrapper");
      if (!card) return; // no card around it — let the link do its job

      var mainImage = card.querySelector(".product-first-image");
      if (!mainImage) return; // nothing to swap — let the link do its job

      event.preventDefault();

      var base = baseline(card);
      var url = swatch.getAttribute("data-kv-url");
      var title = swatch.getAttribute("data-kv-title");

      swapImage(mainImage, swatch.getAttribute("data-kv-img"));

      /* Hover image. If this colourway has no second shot, stop the card
         hovering at all rather than revealing the previous vibe. */
      var inner = card.querySelector(".card-product__media-inner");
      var hover = card.querySelector(".product-secondary-image");
      var hoverSrc = swatch.getAttribute("data-kv-img2");
      if (hover) {
        if (hoverSrc) {
          swapImage(hover, hoverSrc);
          hover.hidden = false;
          if (inner) inner.classList.add("card-product__media-secondary-image");
        } else {
          hover.hidden = true;
          if (inner) inner.classList.remove("card-product__media-secondary-image");
        }
      }

      /* Every link on the card now points at the chosen colourway. */
      Array.prototype.forEach.call(
        card.querySelectorAll("a.product-link"),
        function (link) {
          link.setAttribute("href", url);
          if (title) link.setAttribute("title", title);
        }
      );

      var heading = card.querySelector(".card__heading a");
      if (heading && title) heading.textContent = title;

      /* Quick view has to open the colourway you are looking at. */
      var quick = card.querySelector("quick-view[data-product-url]");
      if (quick) quick.setAttribute("data-product-url", url.split("?")[0]);

      /* Price. No attribute means "same as the card started", so fall
         back to the snapshot rather than leaving the last click's price. */
      var price = swatch.getAttribute("data-kv-price");
      if (price === null) price = base.price;
      replaceFragment(card.querySelector(PRICE_SELECTOR), price, ".price");

      /* Badge, same rule. A stale Sale badge on a full-price colourway
         is a lie, so it is always rewritten, never left in place. */
      var badge = swatch.getAttribute("data-kv-badge");
      if (badge === null) badge = base.badge;
      replaceFragment(card.querySelector(".card__badge"), badge, ".card__badge");

      /* Mark the chosen swatch. */
      var list = swatch.closest(".card-product__swatch-list");
      if (list) {
        Array.prototype.forEach.call(
          list.querySelectorAll("a"),
          function (a) { a.classList.remove("active"); }
        );
        swatch.classList.add("active");
      }
    },
    false
  );
})();
